import React, { useState, createContext, useEffect } from "react";
import data from "../static/data/data.json";
import { createHashHistory } from "history";
import { shuffle } from "../services/data";
import { ga_push } from "../services/analytics";
const AppContext = createContext();
const { Provider } = AppContext;

const AppProvider = ({ children }) => {
  /* ==============
      STATES
     ==============*/
  const [bestSinger, setBestSinger] = useState([0]);
  const [bestSongs, setBestSongs] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [bestArtists, setBestArtists] = useState([0, 0, 0]);
  const [didChoose, setDidChoose] = useState(false);
  const [afterLastDate, setAfterLastDate] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [pageView, setPageView] = useState(0);
  const [votingTextPrimary, setVotingTextPrimary] = useState("");
  const [votingTextSecondary, setVotingTextSecondary] = useState("");
  const [songsCubeShowing, setSongsCubeShowing] = useState([]);
  const [songPlaying, setSongPlaying] = useState(0);
  const [currentAudioTime, setAudioInterval] = useState(0);
  const [currentAudioDuration, setAudioDuration] = useState(0);
  const [songPercentage, setSongPercentage] = useState(0);
  const [prevSong, setPrevSong] = useState(0);
  const [flickAnimation, setFlickAnimation] = useState(false);
  const [songElement, setSongElement] = useState(null);
  const [lastSong, setLastSong] = useState("");
  const [didFill, setDidFill] = useState({
    bestSinger: false,
    bestArtists: false,
    bestSongs: false,
  });

  /* ==============
      USE EFFECTS
     ==============*/
  //randomizes all values
  useEffect(() => {
    if(!window.location.href.includes("https") && !window.location.href.includes("local") && !window.location.href.includes("source")){
      window.location = "https://z.ynet.co.il/mShort/content/2020/glgltz/";
    }
    shuffle(data.Songs);
    shuffle(data.Artists);
    shuffle(data.BestOf);



  }, []);

  //song play management
  useEffect(() => {
    if (!songElement)
      return;

    let audioElement = songElement;

    audioElement.addEventListener("loadedmetadata", (event) => {
      setAudioDuration(event.target.duration);
    });
    audioElement.addEventListener("timeupdate", (event) => {
      // setAudioDuration(event.target.duration);
      setAudioInterval(event.target.currentTime);
    });
    audioElement.addEventListener("ended", (event) => {
      setAudioInterval(0);
      setSongPercentage(0);
      setSongPlaying(0);
    });

    // if (!document.getElementById("tmp_audio")) {
    //   audioElement = document.createElement("video");
    //   audioElement.id = "tmp_audio";
    //   audioElement.setAttribute("playsinline", "playsinline");
    //   audioElement.setAttribute("controls", "controls");
    //   audioElement.setAttribute("preload", "preload");
    //   audioElement.addEventListener("loadedmetadata", (event) => {
    //     setAudioDuration(event.target.duration);
    //   });
    //   audioElement.addEventListener("timeupdate", (event) => {
    //     setAudioInterval(event.target.currentTime);
    //   });
    //   audioElement.addEventListener("ended", (event) => {
    //     setAudioInterval(0);
    //     setSongPercentage(0);
    //     setSongPlaying(0);
    //   });
    //   document.body.appendChild(audioElement);
    // }
    // audioElement = document.getElementById("tmp_audio");

    if (songPlaying == 0 && audioElement) audioElement.pause();

    let currentSong = data.Songs.filter((k) => k.ID == songPlaying)[0]?.Link;
    if (!currentSong) return;

    // if (lastSong != currentSong) {
    //   setAudioDuration(0);
    //   setAudioInterval(0);
    //   setLastSong(currentSong);
    //   // audioElement.src = currentSong;
    // }

    audioElement.currentTime = currentAudioTime;
    if (prevSong != songPlaying) {
      audioElement.currentTime = 0;
      setAudioDuration(0);
      setAudioInterval(0);
      setPrevSong(songPlaying);
    }

    audioElement.pause();
    audioElement.play();
  }, [songPlaying]);


  const playAudio = () => {
    let audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    let xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://besttv228-progressive-video-ynet.cdn.it.best-tv.com/0820/8e166970895e156f32dc5fb5e3683b6d-hd480.mp4');
    xhr.responseType = 'arraybuffer';
    xhr.addEventListener('load', () => {
      let playsound = (audioBuffer) => {
        let source = audioCtx.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(audioCtx.destination);
        source.loop = false;
        source.start();
      };

      audioCtx.decodeAudioData(xhr.response).then(playsound);
    });
    xhr.send();
  }



  useEffect(() => {
    setSongPercentage((currentAudioTime / currentAudioDuration) * 100);
  }, [currentAudioDuration, currentAudioTime]);

  //page view management
  useEffect(() => {
    console.log(pageView);
    if (pageView == 0) {
      window.dataLayer.push({
        event: "virtualPageview",
        virtualPageURL: "/",
        virtualPageTitle: "המצעד הישראלי השנתי",
      });

      setVotingTextPrimary("");
      setVotingTextSecondary("");
    } else if (pageView == 1) {
      setVotingTextPrimary("בחרו מהרשימה עד עשרה שירים שהכי אהבתם השנה,");
      setVotingTextSecondary("יש לבחור לפחות חמישה שירים");
      window.dataLayer.push({
        event: "virtualPageview",
        virtualPageURL: "/Songs",
        virtualPageTitle: "המצעד הישראלי השנתי - שירי השנה",
      });
    } else if (pageView == 2) {
      setVotingTextPrimary("בחרו מהרשימה את השלושה שעשו לכם את השנה");
      setVotingTextSecondary("");
      window.dataLayer.push({
        event: "virtualPageview",
        virtualPageURL: "/Artists",
        virtualPageTitle: "המצעד הישראלי השנתי - אמני השנה",
      });
    } else if (pageView == 3) {
      setVotingTextPrimary("בחרו מהרשימה אמן שהכי אהבתם השנה");
      setVotingTextSecondary("");
      window.dataLayer.push({
        event: "virtualPageview",
        virtualPageURL: "/Breakthrough",
        virtualPageTitle: "המצעד הישראלי השנתי - פריצת השנה",
      });
    } else if (pageView == 4) {
      window.dataLayer.push({
        event: "virtualPageview",
        virtualPageURL: "/Thank-You",
        virtualPageTitle: "המצעד הישראלי השנתי - תודה על ההצבעה",
      });

      setVotingTextPrimary("");
      setVotingTextSecondary("");
    } else {
      setVotingTextPrimary("");
      setVotingTextSecondary("");
    }
    window.scrollTo(0, 0);
  }, [pageView]);

  //vote progress management
  useEffect(() => {
    setDidFill({
      ...didFill,
      bestSinger: bestSinger[0] != 0,
      bestSongs: !bestSongs.includes(0) || bestSongs.indexOf(0) >= 5,
      bestArtists: !bestArtists.includes(0),
    });
  }, [bestSinger, bestArtists, bestSongs]);

  /* ==============
      CUSTOM ACTIONS
     ==============*/
  const toggleSongVote = (id) => {
    if (bestSongs.includes(id)) {
      let index = bestSongs.indexOf(id);
      let arr = bestSongs;
      arr[index] = 0;
      arr = arr.sort((a, b) => b - a);
      setBestSongs([...arr]);
    } else {
      let index = bestSongs.indexOf(0);
      let arr = bestSongs;
      arr[index] = id;
      arr = arr.sort((a, b) => b - a);
      setBestSongs([...arr]);

      if (bestSongs.indexOf(0) == -1) {
        if (!didFill.bestArtists) {
          setPageView(2);
        } else {
          setPageView(3)
        }
      }
    }
  };
  const toggleBestArtistVote = (id) => {
    if (bestArtists.includes(id)) {
      let index = bestArtists.indexOf(id);
      let arr = bestArtists;
      arr[index] = 0;
      arr = arr.sort((a, b) => b - a);
      setBestArtists([...arr]);
    } else {
      let index = bestArtists.indexOf(0);
      let arr = bestArtists;
      arr[index] = id;
      arr = arr.sort((a, b) => b - a);
      setBestArtists([...arr]);
      if (bestArtists.indexOf(0) == -1) {
        setPageView(3);
      }
    }
  };

  const state = {
    songsCubeShowing,
    bestSinger,
    bestSongs,
    bestArtists,
    didChoose,
    afterLastDate,
    shareOpen,
    pageView,
    votingTextPrimary,
    votingTextSecondary,
    songPlaying,
    didFill,
    currentAudioTime,
    currentAudioDuration,
    songPercentage,
    flickAnimation,
    songElement,
  };
  const actions = {
    setSongsCubeShowing,
    setBestSinger,
    setAudioDuration,
    setAudioInterval,
    setBestSongs,
    setBestArtists,
    setDidChoose,
    setAfterLastDate,
    setShareOpen,
    setPageView,
    setVotingTextPrimary,
    setVotingTextSecondary,
    toggleBestArtistVote,
    toggleSongVote,
    setSongPlaying,
    setFlickAnimation,
    setSongElement
  };

  return <Provider value={{ ...state, ...actions }}>{children}</Provider>;
};
export { AppContext, AppProvider };
